import React, { useCallback } from 'react';
import { SearchOutlined } from '../..';
import { CustomInput } from './styled';
export var SearchInput = function SearchInput(_ref) {
  var onChange = _ref.onChange,
      value = _ref.value,
      dropdownPosition = _ref.dropdownPosition,
      size = _ref.size;
  var onClear = useCallback(function () {
    onChange('');
  }, [onChange]);
  var onValueChange = useCallback(function (event) {
    onChange(event.target.value);
  }, [onChange]);
  return /*#__PURE__*/React.createElement(CustomInput, {
    "data-test": "select-search-input",
    dropdownPosition: dropdownPosition,
    value: value,
    variant: "list",
    autoFocus: true,
    onChange: onValueChange,
    onClear: value ? onClear : undefined,
    icon: SearchOutlined,
    size: size
  });
};